<template>
  <v-img
    :src="cropped"
    class="image-display"
    contain
  >
    <template v-slot:placeholder>
      <v-row
        align="center"
        class="fill-height ma-0"
        justify="center"
      >
        <v-progress-circular
          color="grey lighten-3"
          indeterminate
        />
      </v-row>
    </template>
  </v-img>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImageDisplay',
  props: {
    src: {
      type: String,
      require: false,
    },
  },
  data() {
    return {
      cropped: '',
    };
  },
  created() {
    this.load(this.src);
  },
  watch: {
    src(value) {
      this.load(value);
    },
  },
  methods: {
    ...mapActions('imageProcessing', ['cropMargins']),
    load(src) {
      if (!src) {
        return;
      }

      this
        .cropMargins(src)
        .then(url => this.cropped = url);
    },
  },
};
</script>

<style lang="scss" scoped>
.image-display {
  height: 100%;
}
</style>
